import React, { useContext, useEffect } from 'react'
import { Grid } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { UiButton } from '../../../_uiComponents/common/form/UiButton';
import { contextApiActions } from "../../../../_redux/_constants";
import { Context } from "../../../../_context/Store";
import { useDispatch } from 'react-redux';
import { lookupTableCSVFileUploadClear, lookupTableChangeStatus } from '../../../../_redux/_actions';
import { useSelector } from 'react-redux';


export default function ImportedValues(props) {

    const [state, dispatch] = useContext(Context);
    const actionDispatch = useDispatch();
    const { lookupTable } = useSelector((state) => {
        return {
            lookupTable: state.lookupTable,
        };
   });


    const headings = [
        { id: 'columnname ', name: 'Table Name ' },
        { id: 'totalrecords', name: 'Total Records' },
        { id: ' importedrecords', name: ' Imported Records' },
        { id: ' duplicateRecords', name: ' Duplicate Records' },
        { id: ' failedrecords', name: ' Failed Records' },
        { id: ' ', name: '' },
    ]

    const closeValueModal = () => {
        actionDispatch(lookupTableCSVFileUploadClear());
        dispatch({
            type: contextApiActions.UI_LARGE_MODAL_TOGGEL,
            payload: {
                show: false,
            },
        });
    };

    useEffect(() => {
        if(lookupTable?.status === true){
            actionDispatch(lookupTableChangeStatus(false));
        }
    },[lookupTable?.status])

    const downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType })
        const a = document.createElement('a')
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        const clickEvt = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }

    const RecodeDownload = (header, recode) => {
        let headers = [header];
        let data = [...headers, ...recode].join('\n');
        downloadFile({
            data:data,
            fileName: 'File Import.csv',
            fileType: 'text/csv',
        })
    }
    const lookupTableRowFormatter = () => {
        const rows = [{
            name:lookupTable?.csvFileUpload?.name,
            successRecords: lookupTable?.csvFileUpload?.successRecords,
            failedRecords: lookupTable?.csvFileUpload?.failedRecords,
            duplicateRecords: lookupTable?.csvFileUpload?.duplicateRecords
        }];
        return rows;
    }
    return (
        <>
            <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} lg={12}>
                    <div className='sba-table-main-wr'>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650, mt: 0 }} aria-label="simple table" className='sbt-data-grid'>
                                 <TableHead>
                                    <TableRow>
                                        {headings.map((heading, index) => (
                                            <TableCell align="center">
                                                {heading.name}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {lookupTableRowFormatter().map((row, index) => (
                                        <TableRow>
                                            <TableCell align="left">
                                                {row.name}
                                            </TableCell>
                                            <TableCell align="center">
                                                {row?.successRecords?.length + row?.failedRecords?.length + row?.duplicateRecords?.length}
                                            </TableCell>
                                            <TableCell align="center">
                                                {row?.successRecords?.length}
                                            </TableCell>
                                            <TableCell align="center">
                                                {row?.duplicateRecords?.length}
                                            </TableCell>
                                            <TableCell align="center">
                                                {row.failedRecords.length}
                                            </TableCell>
                                            <TableCell align="center">
                                                <Button
                                                    variant="contained"
                                                    onClick={() => RecodeDownload(row.name, row?.successRecords.concat(row?.failedRecords, row?.duplicateRecords))}
                                                >
                                                Download Summary
                                                </Button>

                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                   
                </Grid>
                <Grid item xs={12} lg={12}>
                    <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%', mt: 3 }}>
                        <UiButton name="Close" variant="contained" size="small" onClick={closeValueModal} />
                    </Stack>
                </Grid>
            </Grid>

        </>
    )
}
